(function () {
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const OBSERVER_OPTIONS = {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  };

  let observer = null;

  function animationsEnabled() {
    return document.documentElement.dataset.croScrollAnimations !== 'false';
  }

  function prefersReducedMotion() {
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
  }

  function revealElement(element) {
    element.classList.add('is-visible');
  }

  function getTargets(root) {
    return Array.from(root.querySelectorAll('[data-cro-animate]:not(.is-visible)'));
  }

  function destroyObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function createObserver() {
    destroyObserver();

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        revealElement(entry.target);
        observer.unobserve(entry.target);
      });
    }, OBSERVER_OPTIONS);

    return observer;
  }

  function initCroAnimations(root = document) {
    const targets = getTargets(root);
    if (!targets.length) return;

    if (!animationsEnabled() || prefersReducedMotion()) {
      targets.forEach(revealElement);
      return;
    }

    const activeObserver = observer || createObserver();
    targets.forEach((target) => activeObserver.observe(target));
  }

  function onReady() {
    initCroAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) {
        initCroAnimations(event.target);
      }
    });
  }

  window.matchMedia(REDUCED_MOTION_QUERY).addEventListener('change', (event) => {
    if (event.matches) {
      destroyObserver();
      getTargets(document).forEach(revealElement);
    } else if (animationsEnabled()) {
      initCroAnimations();
    }
  });
})();
